import { render, staticRenderFns } from "./SliceList.vue?vue&type=template&id=dce7ee90&scoped=true&"
import script from "./SliceList.vue?vue&type=script&lang=js&"
export * from "./SliceList.vue?vue&type=script&lang=js&"
import style0 from "./SliceList.vue?vue&type=style&index=0&id=dce7ee90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce7ee90",
  null
  
)

export default component.exports